import { type SchedulerPro } from '@bryntum/schedulerpro'
import { updateSchedulerColumnsSectionWidth } from '../../../../atoms/columns'

export function storeColumnsSubgridWidth(scheduler: SchedulerPro) {
  updateSchedulerColumnsSectionWidth(scheduler.subGrids['cols'].width)
}
